// extracted by mini-css-extract-plugin
export default {"container":"Sidenav_container__UoLvp","inner":"Sidenav_inner__QohMr","logo":"Sidenav_logo__8vzHp","links":"Sidenav_links__suQn9","limitedUser":"Sidenav_limitedUser__2Txmb"};